import { apiInstance } from "../utils/_apiInstance";

export interface SaveSearchParams {
  nome: string;
  tipo: string;
  parametros: {
    q: string;
    limit?: number;
    page?: number;
    sort?: string;
    collectionType: string;
    [key: string]: any;
  };
  url: string;
}

export const saveSearch = async (data: SaveSearchParams) => {
  const response = await apiInstance.post("/pesquisas-salvas", data);
  return response.data;
};
